import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryHighlights() {
  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            攻略分类导航
          </h2>
          <p className="text-sm text-foreground-500">选择你感兴趣的攻略类别，快速找到需要的内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category?cat=${cat.id}`}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300 flex-shrink-0">
                  <i className={`${cat.icon} text-primary-500 group-hover:text-background-50 text-xl transition-colors duration-300`}></i>
                </span>
                <div>
                  <h3 className="text-base font-semibold text-foreground-800 mb-1.5">{cat.name}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{cat.desc}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}